import * as types from '../types.js';

export default {

	html: `
		<style>
			#sm-split #stock_sku { width: 12rem; }
			#sm-split #quantity_first { width: 8rem; text-align: right; }
			#sm-split #stock_id, #sm-split #lot_ref { width: 11rem; }
			#sm-split #product_name {
				width: min(100%, 42rem);
				min-height: 2.6rem;
				resize: vertical;
				font-weight: 600;
			}
			#sm-split #manufacturer_nick,
			#sm-split #program_name { width: 14rem; }
			#sm-split #lot_number, #sm-split #expiration_date { width: 11rem; }
			#sm-split .sm-split-product-block { max-width: 46rem; }
		</style>
		<form id="sm-split" class="form" autocomplete="off">
			<div class="title">Dividir linha de estoque</div>
			<p class="mts muted" style="max-width:46rem">Exige reserva e bloqueio zerados. Informe a quantidade que permanece na linha atual; o restante gera uma nova linha na mesma posição/lote.</p>
			<div class="fsb mtl sm-split-product-block">
				<label title="Nome completo do produto (não truncado)">Produto
					<textarea id="product_name" rows="2" disabled></textarea>
				</label>
			</div>
			<div class="fsb mtm">
				<label title="Fabricante">Fabricante
					<input id="manufacturer_nick" type="text" disabled>
				</label>
				<label title="Programa do lote">Programa
					<input id="program_name" type="text" disabled>
				</label>
				<label title="Lote do fabricante">Lote fab.
					<input id="lot_number" type="text" disabled>
				</label>
				<label title="Data de validade do lote">Validade
					<input id="expiration_date" type="text" disabled>
				</label>
			</div>
			<div class="fsb mtm">
				<label>Estoque ID
					<input id="stock_id" type="text" disabled>
				</label>
				<label>Lote atual
					<input id="lot_ref" type="text" disabled>
				</label>
				<label>SKU
					<input id="stock_sku" type="text" disabled>
				</label>
				<label>Disponível (atual)
					<input id="qty_available" type="text" disabled>
				</label>
				<label>Qtde na linha atual após split<sup>*</sup>
					<input id="quantity_first" type="text" required>
				</label>
			</div>
			<div class="mtm">
				<label style="display:flex;align-items:flex-start;gap:0.45rem;max-width:46rem">
					<input id="isolate_new_lot" type="checkbox" style="margin-top:0.15rem">
					<span>Criar <strong>lote independente</strong> para a linha nova (recomendado quando você quer editar lote/data/programa apenas na linha splitada, sem impactar a linha original).</span>
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class='bn_Escape button'>Fechar</button>
					<button type="button" class='bn_Enter button'>Dividir</button>
				</span>
			</div>
		</form>
	`,

	form: {
		selector: '#sm-split',
		init(formset) {
			formset.form.eraseValues();
			Object.getPrototypeOf(this).init.call(this);
		},
	},

	fields: [
		{ properties: { selector: '#product_name' }, types: [] },
		{ properties: { selector: '#manufacturer_nick' }, types: [] },
		{ properties: { selector: '#program_name' }, types: [] },
		{ properties: { selector: '#lot_number' }, types: [] },
		{ properties: { selector: '#expiration_date' }, types: [] },
		{ properties: { selector: '#stock_id' }, types: [] },
		{ properties: { selector: '#lot_ref' }, types: [] },
		{ properties: { selector: '#stock_sku' }, types: [] },
		{ properties: { selector: '#qty_available' }, types: [] },
		{ properties: { selector: '#isolate_new_lot' }, types: [ types.pubsub() ] },
		{ properties: { selector: '#quantity_first' }, types: [ types.number(0, 2) ] },
	],
};
